export const clinicianApplicationKeys = {
  all: ['clinicianApplication'] as const,
};
